import { listSideNavThemes } from "../../services/defs/internal-api";

// Themes change rarely (admin-only mutations) and the mutations explicitly
// invalidate this query, so a generous staleTime prevents thrash on tab refocus
// and SPA navigation.
const SIDE_NAV_THEMES_STALE_TIME_MS = 5 * 60 * 1000;

const queryScope = (companyId?: string) => companyId ?? "self";

export const sideNavThemesQuery = (companyId?: string) => ({
	queryKey: ["side-nav-themes", queryScope(companyId)] as const,
	queryFn: () => listSideNavThemes(companyId),
	staleTime: SIDE_NAV_THEMES_STALE_TIME_MS,
	meta: {
		errorMessage: "There was an error loading side-nav themes.",
	},
});
